module.exports = __webpack_public_path__ + "img/Integration-ofCombatSystem.f6599fc4.jpg";